module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "panel",
    class: ['tab-pane', {
      'active fade': _vm.active,
      'in': _vm.fadein
    }],
    attrs: {
      "role": "tabpanel"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-58ac87cb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58ac87cb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Tab.vue
// module id = 168
// module chunks = 0